import { IconWithHover } from '@/components/IconWithHover';
import { SIDEBAR_WIDTH } from '@/components/NewSidebar';
import XIcon from '@/images/Close.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const BulkActionsBarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - ${SIDEBAR_WIDTH});
    height: 80px;
    background: ${theme.colors.black[50]};
    box-shadow: 4px 0 5px 2px rgba(187, 187, 187, 0.24);
    position: fixed;
    bottom: 0;
    right: 0;
    padding-inline: 24px;
    z-index: 16;
`;

const InfoText = styled(Typography)`
    color: ${theme.colors.black[700]};
    font-weight: 500;
`;

interface Props {
    selectedElementsCount: number;
    reset: () => void;
    children: React.ReactNode;
}

export const BulkActionsBar = ({ children, selectedElementsCount, reset }: Props) => {
    if (!selectedElementsCount) {
        return null;
    }

    return (
        <BulkActionsBarContainer>
            <InfoText>{selectedElementsCount} selected</InfoText>
            {children}
            <IconWithHover src={XIcon} size="16px" onClick={reset} />
        </BulkActionsBarContainer>
    );
};
